import { gql } from '@apollo/client';


export const ADDRESS_HISTORY = gql`
  query addressHistory($addressId: ID!, $originatorId: ID!){
    addressHistory(addressId: $addressId, originatorId: $originatorId) {
      id
      incidentNumber
      classification {
        id
        name
      }
      callTime
      locked
      sealed
      officerIncidentSpecifics {
        id
	   		primaryOfficer
        officer {
          id
          deptAttribute {
            id
            badge
          }
        }
      }
      incidentDetail {
        id
        occurredTo
        occurredFrom
      }
    }
  }
`;